function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.2346
}, /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(90)",
  x: 19.908,
  y: -81.779,
  width: 85.185,
  height: 24.691
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(90)",
  x: 39.66,
  y: -42.913,
  width: 45.679,
  height: 24.691
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(90)",
  x: 58.179,
  y: -95.062,
  width: 8.642,
  height: 90.123
}));

var SvgAlignCenterV = function SvgAlignCenterV(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 125",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlignCenterV, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/align-center-v.9b55a0f4.svg";
export { ForwardRef as ReactComponent };